import clsx from "clsx";

const scenes = {
  "Alice-Bob": {
    src: "/assets/scenes/Scene-Alice-Bob.gif",
    width: 77,
    height: 58,
  },
  "Bob-hovering-Alice": {
    src: "/assets/scenes/Scene-Bob-hovering-Alice.gif",
    width: 68,
    height: 42,
  },
  "Mallory-sneaking-Bob": {
    src: "/assets/scenes/Scene-Mallory-sneaking-Bob.gif",
    width: 80,
    height: 45,
  },
  "Yves-spying-Alice": {
    src: "/assets/scenes/Scene-Yves-spying-Alice.gif",
    width: 82,
    height: 42,
  },
};

type Props = {
  className?: string;
  scene: keyof typeof scenes;
};

export function Scene({ className, scene }: Props) {
  const { src, width, height } = scenes[scene];

  return (
    <img
      className={clsx(className, "u-pixel-art")}
      src={src}
      alt=""
      width={width}
      height={height}
      style={{
        width: `calc(${width}px * 2)`,
        height: `calc(${height}px * 2)`,
      }}
    />
  );
}
